import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import Script from 'next/script';

const GoogleAnalyticsScript = ({ tagId, }) => (jsxs(Fragment, { children: [jsx(Script, { src: `https://www.googletagmanager.com/gtag/js?id=${tagId}`, strategy: "afterInteractive" }), jsx(Script, { id: "google-analytics-initialization", strategy: "afterInteractive", children: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${tagId}');
      ` })] }));

export { GoogleAnalyticsScript as G };
//# sourceMappingURL=component-DoBza_xN.js.map
